// extracted by css-extract-rspack-plugin
export default {"Box":"roadmap-table-layout-module__Box__GCB1D","Box_1":"roadmap-table-layout-module__Box_1__jLBS8"};